import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as actions from '../actions';
import * as selectors from '../selectors';

import { SegmentEditForm } from './forms';

const SegmentEditCard = (props) => {
    const escFunction = (event) => {
        if (event.key === 'Escape') props?.resetForm();
    };

    useEffect(() => {
        document.addEventListener('keydown', escFunction, false);

        return () => {
            document.removeEventListener('keydown', escFunction, false);
        };
    }, []);

    return <SegmentEditForm {...props} />;
};

const mapStateToProps = createStructuredSelector({
    initialValues: selectors.getInitialValues,
});

const mapDispatchToProps = (dispatch) => ({
    resetForm: () => dispatch(actions.resetForm()),
});

SegmentEditCard.propTypes = {
    resetForm: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(SegmentEditCard);
